import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = ({ onScrollToConnections }) => {
  const benefits = [
    {
      icon: 'Shuffle',
      title: 'Cross-Platform Sync',
      description: 'Transfer playlists seamlessly between Spotify and YouTube Music'
    },
    {
      icon: 'Zap',
      title: 'Smart Matching',
      description: 'Advanced algorithms match songs by title, artist, and duration'
    },
    {
      icon: 'Shield',
      title: 'Secure & Private',
      description: 'OAuth authentication ensures your accounts stay protected'
    }
  ];

  return (
    <div className="text-center mb-12">
      {/* Main Hero Content */}
      <div className="mb-8">
        <div className="flex items-center justify-center mb-6">
          <div className="flex items-center justify-center w-16 h-16 bg-primary/10 rounded-2xl">
            <Icon name="Music" size={32} className="text-primary" />
          </div>
        </div>
        
        <h1 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
          Connect Your Music Accounts
        </h1>
        
        <p className="text-lg text-text-secondary max-w-2xl mx-auto mb-6">
          Link your Spotify and YouTube Music accounts to start syncing playlists across platforms. 
          Keep your music collection unified and accessible everywhere.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-4">
          <Button
            variant="primary"
            size="lg"
            onClick={onScrollToConnections}
            iconName="ArrowRight"
            iconPosition="right"
            iconSize={20}
          >
            Get Started
          </Button>
          
          <Button
            variant="ghost"
            size="lg"
            iconName="Play"
            iconSize={20}
          >
            Watch Demo
          </Button>
        </div>
      </div>

      {/* Benefits Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl  mx-auto">
        {benefits.map((benefit, index) => (
          <div key={index} className="p-6 bg-surface border border-border rounded-xl shadow-elevation-1 hover:shadow-elevation-2 transition-all duration-300">
            <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-xl mx-auto mb-4">
              <Icon name={benefit.icon} size={24} className="text-primary" />
            </div>
            
            <h3 className="text-lg font-semibold text-text-primary mb-2">
              {benefit.title}
            </h3>
            
            <p className="text-sm text-text-secondary leading-relaxed">
              {benefit.description}
            </p>
          </div>
        ))}
      </div>

      {/* Stats Section */}
      <div className="mt-12 p-6 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-xl border border-primary/20 max-w-6xl  mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
          <div>
            <div className="text-2xl font-bold text-primary mb-1">10M+</div>
            <div className="text-sm text-text-secondary">Songs Synced</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-primary mb-1">50K+</div>
            <div className="text-sm text-text-secondary">Active Users</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-primary mb-1">99.9%</div>
            <div className="text-sm text-text-secondary">Match Accuracy</div>
          </div>
        </div>
      </div>

      {/* Trust Indicators */}
      <div className="mt-8 flex items-center justify-center space-x-6 text-text-muted">
        <div className="flex items-center space-x-2">
          <Icon name="Shield" size={16} className="text-success" />
          <span className="text-sm">SSL Encrypted</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Lock" size={16} className="text-success" />
          <span className="text-sm">OAuth Secure</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="CheckCircle" size={16} className="text-success" />
          <span className="text-sm">GDPR Compliant</span>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;